import userFriendlyEr from '../../utils/userFriendlyEr.js'
import permissionMixin from '../../mixins/permission-mixin.js'
import {PERMS} from '../../config/permissions.js'

export default {
  mixins: [permissionMixin],
  data () {
    return {
      data: {},
      meta: null,
      editableIds: {},
      scrollLeft: 0,
      scrollTop: 0,
      marginOnScrollReleased: 0, // 14

      error: null
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    showActionButtons () {
      return this.$scopedSlots['buttons'] || (this.acceptEdit || this.acceptDelete)
    },
    acceptDelete () {
      return this.enabledActions.indexOf(PERMS.DELETE) > -1 && this.userCanDelete
    },
    acceptCreate () {
      return this.enabledActions.indexOf(PERMS.CREATE) > -1 && this.userCanCreate
    },
    acceptEdit () {
      return this.enabledActions.indexOf(PERMS.EDIT) > -1 && this.userCanEdit
    },
    hasRightFixedCols () {
      return this.acceptEdit || this.acceptDelete
    },
    colspan () {
      let colspan = Object.keys(this.attributes).length
      colspan++
      return colspan
    },
    showSummaryColumns () {
      return this.summaryColumns.length > 0
    },
    sortedFields () {
      if (this.meta && this.meta.sort && typeof this.meta.sort === 'object') {
        return this.meta.sort
      }
      return {}
    },
    tableInOfflineMode () {
      return !this.tableInOnlineMode
    },
  },
  methods: {
    getData () {
      return this.data.data || []
    },
    onChangeModelValue (attr, name, model) {
      if (attr.hasOwnProperty('change')) {
        attr.change(model)
      }
    },
    onPaginate ($event) {
      this.$emit('paginate', $event)
    },
    sortByField (fieldName, direct) {
      let sort = null
      if (direct === 'desc') {
        sort = `-${fieldName}`
      } else if (direct === 'asc') {
        sort = `${fieldName}`
      }
      this.$emit('sortByField', {sort})
    },
    getSumOf (fieldName) {
      if (this.summaryColumns.indexOf(fieldName) === -1) {
        return ' - '
      }

      let sum = 0
      if (this.data && this.data.data) {
        this.data.data.forEach(v => {
          if (v.hasOwnProperty(fieldName) && !isNaN(+v[fieldName])) {
            sum = +sum + (+v[fieldName])
          }
        })
      }
      // fix: iee754
      // https://medium.com/@julienetienne/was-javascript-poorly-designed-part-3-ieee-754-df8cbd1aa0dd
      sum = sum.toFixed(3)
      if (isNaN(sum)) {
        sum = 0
      }
      if (this.attributes[fieldName] && this.attributes[fieldName].calcSum) {
        return this.attributes[fieldName].calcSum(this, sum)
      }
      return sum
    },
    checkBindDisabled (name, model) {
      let bindDisabled = false
      let isDoesntSavedNewModel = true
      if (!this.tableInOfflineMode) {
        if (model.id) {
          isDoesntSavedNewModel = false
        }
      } else {
        if (model._considerSaved === true) {
          isDoesntSavedNewModel = false
        }
      }
      if (this.enableOnAdd.length > 0 && isDoesntSavedNewModel === true) {
        if (this.enableOnAdd.indexOf(name) > -1) {
          bindDisabled = false
        } else {
          bindDisabled = true
        }
      }

      if (this.attributes[name].disabled) {
        bindDisabled = true
      }

      return bindDisabled
    },
    getListPlaceholder (model, attr) {
      if (typeof attr.placeholder !== 'undefined') {
        return attr.placeholder
      }
      return null
    },
    getPlaceholder (model, attr) {
      if (typeof attr.placeholder !== 'undefined') {
        return attr.placeholder
      }
      return this.defaultPlaceholder
    },
    onChange ($event, model, attr) {
      attr.suggestion.onChange(this, $event, model, attr)
    },
    onSelectItem ($event, model, attr) {
      attr.suggestion.onSelect(this, $event, model, attr)
      this.saveAfterChange(model)
    },
    getValidationError (model, attr) {
      if (model.errors) {
        if (model.errors[attr]) {
          return model.errors[attr]
        }
      }
      return null
    },
    // TODO: need for fix bug in src/app/registry/
    // components/technology-table.vue afterValidate
    openEditMode (value) {
      let id = value.id || value._storeUUID
      this.$set(this.editableIds, id, true)
    },
    closeEditMode (value) {
      let tmp = Object.assign({}, this.editableIds)
      let id = value.id || value._storeUUID
      tmp[id] = false
      this.editableIds = null
      this.editableIds = tmp
    },
    toggleEditable (value, rowIndex = -1, skipSaveRow = false) {
      let tmp = Object.assign({}, this.editableIds)
      let id = value.id || value._storeUUID
      console.log('Edited id' + id)
      if (tmp[id]) {
        if (!skipSaveRow) {
          this.saveRow(value, rowIndex).then(r => {
            if (r && r === true) {
              tmp[id] = false
            }
            this.afterEditRow(value, rowIndex)
          })
        } else {
          tmp[id] = false
        }
      } else {
        if (!this.acceptEdit) {
          console.log('No permisisons for edit')
          return
        }
        tmp[id] = true
      }
      this.editableIds = null
      this.editableIds = tmp
    },
    isEdit (value) {
      let id = value.id || value._storeUUID
      return this.editableIds && this.editableIds[id]
    },
    deleteRow (value) {
      if (!this.acceptDelete) {
        console.log('No permisisons for delete')
        return
      }

      this.$e.confirmBox().then(() => {
        console.log('deleteRow')
        let offline = value.id ? false : true
        let url = this.deleteUrl(this, value)
        if (url === null) {
          offline = true
        }
        this.$sharedServices.store.dispatch('deleteModel', {
          endpoint: this.dataUrl,
          url: this.deleteUrl(this, value),
          data: value,
          // if model doesnt create, dont send response and delete from store only
          offline: offline
        }).then(r => {
          this.afterDeleteRow(r, value)
          this.afterEditRow(value)
        }).catch(e => {
          console.error(e)
          this.$e.errorBox(e)
        })
      })
    },
    createRow (newRowParams = null, onSuccessCb) {
      if (!this.acceptCreate) {
        console.log('No permisisons for createRow ' + this.enabledActions)
        return false
      }

      if (!newRowParams) {
        return false
      }

      if (this.onlyOneAdd && this.data && this.data.data && this.data.data.length > 0) {
        // search for new
        let newIndex = -1
        this.data.data.forEach((v, i) => {
          if (this.tableInOfflineMode) {
            // mixed mode, offile and real save
            if (v.hasOwnProperty('_considerSaved')) {
              // full offline
              if (!v._considerSaved) {
                newIndex = i
              }
            } else {
              // mixed
              if (!v.id) {
                newIndex = i
              }
            }
          } else {
            if (!v.id) {
              newIndex = i
            }
          }
        })

        if (newIndex > -1 && this.$refs.rows && this.$refs.rows.length > 0) {
          try {
            let inputs = this.$refs.rows[newIndex].getElementsByTagName('input')
            // check for input disabled
            for (let el of inputs) {
              // focus on first not disabled
              if (!el.disabled) {
                this.focusOnFieldInRow(el)
                break
              }
            }
          } catch (e) {
            console.error(e)
          }
        }

        if (newIndex > -1) {
          return false
        }
      }

      this.addRow(newRowParams, onSuccessCb)
      return true
    },
    focusOnFieldInRow (domElement) {
      domElement.focus()
    },
    validateRow (model, disableFocus = true) {
      // for skip row
      model._isValid = false

      let errors = {}
      let focused = false

      let trs, td, tr, input, attrName, modelId, rowId, tds
      modelId = model.id || model._storeUUID || 0
      // find tr and tds of that model
      try {
        trs = this.$refs.table.getElementsByTagName('tr')
        if (trs) {
          for (let searchTr of trs) {
            rowId = searchTr.getAttribute('data-id')
            if (rowId == modelId) {
              tds = searchTr.getElementsByTagName('td')
              tr = searchTr
            }
          }
        }
      } catch (e) {
        console.error(e)
      }
      for (let key in this.attributes) {
        if (typeof model[key] === 'undefined') {
          this.$set(model, key, '')
        } else if (model[key] === null) {
          this.$set(model, key, '')
        }
        let msg = ''

        let valueAsString = model[key].toString()
        if (this.attributes[key]['required'] && valueAsString.length < 1) {
          msg += 'Заполните поле. '
        }

        let validationRule = this.attributes[key]['validationRulePattern'] || this.defaultValidationRulePattern
        if (typeof model[key] !== 'object' && model[key] !== '' && validationRule) {
          let regExp = new RegExp(validationRule, 'i')
          if (regExp.test(model[key]) === false) {
            if (this.attributes[key].invalidMessage) {
              msg += this.attributes[key].invalidMessage
            } else {
              msg += 'Неверный формат. '
            }
          }
        }

        if (msg !== '') {
          errors[key] = msg

          // focus on error
          if (!focused) {
            if (disableFocus === true) {
              continue
            }
            // console.log(this.$refs.table, tds)
            try {
              if (tds) {
                for (let td of tds) {
                  attrName = td.getAttribute('data-name')
                  if (attrName == key) {
                    input = td.getElementsByTagName('input')
                    if (input && input[0]) {
                      this.focusOnFieldInRow(input[0])
                      // console.log('focus', attrName, input[0])
                    } else {
                      this.focusOnFieldInRow(td)
                      // console.log('focus', attrName, td)
                    }
                    focused = true
                    break
                  }
                }
              }
              if (focused) {
                break
              }
            } catch (e) {
              console.error(e)
            }
          }
        }
      }

      errors = this.afterValidate(this, model, errors, {
        trs: trs,
        tr: tr,
        td: td,
        input: input
      })
      model.errors = null
      model.errors = errors

      if (Object.keys(errors).length > 0) {
        return false
      }

      model._isValid = true
      return true
    },
    addRow (newRowParams = {}, onSuccessCb) {
      if (!this.acceptCreate) {
        console.log('No permisisons for addRow')
        return false
      }

      let model = Object.assign(newRowParams, {
        // used in new records in offline endpoints save
        _isValid: false,
        _considerSaved: false,
        // error object
        errors: {}
      })

      model = this.prepareRow(model, 'addRow')

      this.$sharedServices.store.dispatch('createModel', {
        endpoint: this.dataUrl,
        data: model,
        offline: true,
        action: 'prepend'
      }).catch(e => {
        console.error(e)
      }).then(response => {
        if (this.tableInOfflineMode) {
          this.fetchData()
          this.toggleEditable(model)
          this.afterCreateRow(response, model)
        } else {
          if (this.data && this.data.data) {
            this.openEditMode(response.data)
            // this.editableIds[response.data._storeUUID] = true
            this.afterCreateRow(response, model)
          } else {
            this.$e.warningBox(
              'Ранее был получен неверный GET ответ от сервера, требуемый формат: {data:[]} в ' + this.dataUrl
            )
          }
        }
        if (onSuccessCb) {
          onSuccessCb(model)
        }
      })
    },
    /**
     * Called after edit close or row removed
     * @param model
     * @param rowIndex
     */
    afterEditRow (model, rowIndex = 1) {
      this.$emit('afterEditRow', {
        action: 'afterEditRow',
        model: model,
        rowIndex: rowIndex
      })
    },
    afterDeleteRow (response, model) {
      this.$emit('afterDeleteRow', {
        action: 'afterDeleteRow',
        response: response,
        model: model
      })
    },
    afterSaveRow (response, model, rowIndex) {
      this.$emit('afterSaveRow', {
        action: 'afterSaveRow',
        response: response,
        model: model,
        rowIndex: rowIndex
      })
    },
    afterCreateRow (response, model) {
      this.$emit('afterCreateRow', {
        action: 'afterCreateRow',
        response: response,
        model: model
      })
    },
    afterFetchDataEvent (response) {
      this.$emit('afterFetchData', {
        action: 'afterFetchData',
        response: response
      })
    },
    findByIdAndSetDataAndSave (id, data = {}) {
      if (this.data && this.data.data) {
        let pk = 'id'
        if (this.tableInOfflineMode) {
          pk = '_storeUUID'
        }
        this.data.data.forEach(v => {
          if (v[pk] == id) {
            for (let key in data) {
              v[key] = data[key]
            }
            this.saveRow(v)
          }
        })
      }
    },
    saveAfterChange (model, ...args) {
      if (!this.autoSaveAfterChange) {
        return Promise.resolve()
      }
      return this.saveRow(model, ...args)
    },
    // TODO: check enableEditAfterSave parametr
    // TODO: remove rowIndex, now used data attrs
    // may be have revert logic
    saveRow: async function (model, rowIndex = -1, enableEditAfterSave = true, options = {}) {
      let {forceOnlineOnSave = false, disableErrorMessages = false} = options
      let tableInOfflineMode = this.tableInOfflineMode
      if (forceOnlineOnSave === true) {
        tableInOfflineMode = false
      }
      /* if (this.enabledActions.indexOf('edit') === -1) {
        console.log('No permisisons for saveRow')
        return false
      } */

      model = this.prepareRow(model, 'saveRow')

      if (this.validateRow(model) === false) {
        console.log('validation failed', model, model.errors)

        this.$forceUpdate()
        return false
      } else {
        // for reset previos validation errors
        this.$forceUpdate()
      }

      console.log('saving:1 mode', tableInOfflineMode)

      if (!model.id) {
        if (!tableInOfflineMode) {
          this.$bar.start()
        } else {
          // if new
          if (!model._considerSaved) {
            model._considerSaved = true
            this.openEditMode(model)
            // this.editableIds[model._storeUUID] = true
          }

          if (this.exitFromEditModeAfterSave === true) {
            this.closeEditMode(model)
            this.$forceUpdate()
            return true
          }

          if (!enableEditAfterSave) {
            this.toggleEditable(model)
          }

          return true
        }

        if (!this.acceptCreate) {
          return false
        }
        // for prevent duplicate saving
        if (model._isSaving) {
          return false
        }
        model._isSaving = true
        await this.beforeSaveResponse(
          model,
          'createModel',
          tableInOfflineMode,
          this
        )
          .then(() => this.$sharedServices.store.dispatch('createModel', {
            endpoint: this.dataUrl,
            url: this.postUrl(this, model),
            offline: tableInOfflineMode,
            data: model
          }))
          .then(r => {
            model._isSaving = false
            this.afterSaveRow(r, model, rowIndex)
            this.$bar.finish()

            model.errors = null
            if (r.data && r.data.id) {
              this.openEditMode(r.data)
              // this.editableIds[r.data.id] = true
              // @fix: dont open table after edit
              this.$forceUpdate()

              if (this.exitFromEditModeAfterSave === true) {
                this.closeEditMode(model)
                this.$forceUpdate()
                return true
              }

              if (!enableEditAfterSave) {
                this.toggleEditable(model)
              }
            } else {
              console.error('Unknown condition')
            }
            return r
          })
          .catch(e => {
            model._isSaving = false
            if (!tableInOfflineMode && disableErrorMessages === false) {
              this.$e.warningBox(this.getErrorMessage(e))
            }

            this.$bar.finish()
            console.error(e)
            model.errors = e.data.errors

            // fix: close after save
            this.openEditMode(model)
            // this.editableIds[model._storeUUID] = true
            this.$forceUpdate()
            return Promise.reject(
              this.getErrorMessage(e)
            )
          })
      } else {
        if (!this.acceptEdit) {
          return false
        }

        const patchUrl = this.patchUrl(this, model)
        if (patchUrl === null) {
          console.warn('row edit endpoint disabled')
          this.$bar.finish()
          return true
        }
        await this.beforeSaveResponse(
          model,
          'updateModel',
          tableInOfflineMode,
          this
        )
          .then(() => this.$sharedServices.store.dispatch('updateModel', {
            endpoint: this.dataUrl,
            url: patchUrl,
            data: model,
            offline: tableInOfflineMode
          }))
          .then(r => {
            this.afterSaveRow(r, model, rowIndex)

            this.$bar.finish()
            model.errors = null

            if (this.exitFromEditModeAfterSave === true) {
              this.closeEditMode(model)
              this.$forceUpdate()
              return true
            }

            if (!enableEditAfterSave) {
              this.toggleEditable(model)
            }
            return r
          })
          .catch(e => {
            console.error(e)

            if (!tableInOfflineMode && disableErrorMessages === false) {
              this.$e.warningBox(this.getErrorMessage(e))
            }

            this.$bar.finish()
            model.errors = e.data.errors
            // fix: close after save
            this.openEditMode(model)
            // this.editableIds[model.id] = true
            this.$forceUpdate()
            return Promise.reject(
              this.getErrorMessage(e)
            )
          })
      }

      this.$forceUpdate()
      return true
    },
    getErrorMessage (e) {
      if (e && e.status === 422) {
        return userFriendlyEr.recognizeServerValidation(e)
      }
      return userFriendlyEr.recognize(e)
    },
    delay (delay) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(1)
          console.log('delay')
        }, delay)
      })
    },
    saveAllRows: async function (forceOnlineOnSave = true, disableErrorMessages = true) {
      // set delay for vue can change values in watchers
      await this.delay(200)
      let errors = []
      console.log('this.data', this.data, this.tableInOfflineMode)
      if (this.data && this.data.data) {
        for (let i = 0; i < this.data.data.length; i++) {
          let model = this.data.data[i]
          console.log('saving')
          let result = await this.saveRow(model, -1, true, {
            forceOnlineOnSave,
            disableErrorMessages
          })
          if (!result) {
            errors.push(model)
          }
        }
      }
      if (errors.length > 0) {
        return Promise.reject(errors)
      }
      return Promise.resolve(1)
    },
    fetchData () {
      if (this.dataUrl) {
        if (!this.tableInOfflineMode) {
          this.$bar.start()
        }
        const endpoint = this.dataUrl
        this.error = null
        this.$sharedServices.store.dispatch('updateUrlEndpoint', {
          endpoint,
          offline: this.tableInOfflineMode,
          params: {
            disableGlobalError: true
          }
        }).then(r => {
          this.data = null
          this.data = Object.assign({}, r.data)
          this.meta = Object.assign({}, r.data._meta || {})

          if (this.data.data && this.data.data.length) {
            this.data = this.afterFetchData(this, this.data)
            for (let i = 0; i < this.data.data.length; i++) {
              // set is saved and valid
              if (this.data.data[i].id) {
                this.data.data[i]._isValid = true
                this.data.data[i]._considerSaved = true
              } else {
                if (!this.data.data[i].hasOwnProperty('_considerSaved')) {
                  this.data.data[i]._considerSaved = false
                }
                if (!this.data.data[i].hasOwnProperty('_isValid')) {
                  this.data.data[i]._isValid = false
                }
              }
            }
          }

          this.$bar.finish()
          this.afterFetchDataEvent(r)
        }).catch(e => {
          this.data = null
          this.$bar.finish()
          this.error = userFriendlyEr.recognize(e, endpoint)
          console.error(e)
        })
      }
    }
  }
}
